<template>
  <v-container fluid grid-list-lg class="pa-3">
    <v-layout row wrap>
      <v-flex>
				<v-card>
					<v-toolbar dense prominent>
						<v-icon>list</v-icon>
              <v-toolbar-title>Event Listing</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-toolbar-items>
							<!-- <v-toolbar-items v-if="roles.auth_role"> -->
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn small fab :href="'events_crud?uuid=73953984-a422-4608-b430-bc0f91bbcaaa&_id='" v-on="on">
                      <v-icon>add_circle_outline</v-icon>
                    </v-btn>
                  </template>
                  <span>Add Event</span>
                </v-tooltip>
              </v-toolbar-items>
					</v-toolbar>

					<v-card-text class="pa-0">
						<v-expansion-panel>
							<v-expansion-panel-content class="accent">
                <template v-slot:header>
                  <div style="font-size: medium;">Filter Panel</div>
                </template>

								<v-container fluid class="pt-0">
                  <v-layout row wrap>
                    <v-flex class="text-xs-right">
                      <v-btn color="orange" small fab @click="selected_filter.push({field:'', value:'', type:''})"><v-icon color="white">add</v-icon></v-btn>
                      <v-btn color="green" @click="refreshData()">GENERATE NOW</v-btn>
                      <v-btn color="cyan lighten-1" @click="selected_filter=[], refreshData()">RESET FILTER</v-btn>
                    </v-flex>
                  </v-layout>
									
                  <v-layout row wrap>
                    <v-flex>
                      <v-card>
                        <v-card-text v-if="selected_filter.length > 0">
                          <v-layout row wrap align-center
                            v-for="(item,i) in selected_filter"
                            :key="i"
                          >                                
                            <v-flex xs12 md5>
                              <v-select
                                v-model="selected_filter[i].field"
                                :items="get_filterable_columns"
                                @change="d_onchange(selected_filter[i])"
                                clearable
                                item-text="text"
                                item-value="value"
                                label="select field"
                              ></v-select>
                            </v-flex>
                            <v-flex xs12 md1 class="text-md-center">
                              contains
                            </v-flex>
                            <v-flex xs12 md5>
                              <v-text-field
                                v-model="selected_filter[i].value"
                                label="your text"
                              ></v-text-field>
                            </v-flex>
                            <v-flex xs12 md1>
															<div class="text-xs-center">
                                <v-btn color="red" small fab @click="selected_filter.splice(i,1)" :disabled="false"><v-icon color="white">clear</v-icon></v-btn>
															</div>
                            </v-flex>
                          </v-layout>
                          
                        </v-card-text>
                      </v-card>
                    </v-flex>
                  </v-layout>

								</v-container>
							</v-expansion-panel-content>
						</v-expansion-panel>

						<v-data-table
              :headers="table.headers.filter(el=>el.visible == true)"
              :items="table.items"
              :loading="table.loading"
              must-sort
              :pagination.sync="table.pagination"
              :rows-per-page-items="table.rows_per_page_items"
              :total-items="table.total_items"
              class="elevation-1"
						>
              <v-progress-linear color="blue" indeterminate>
                <template v-slot:progress>
                </template>
              </v-progress-linear>
              <template v-slot:items="props">
                <td class="pa-1 pl-3">{{ props.item._id }}</td>
                <td class="pa-1">{{ props.item.type }}</td>
                <td class="pa-1">{{ props.item.label }}</td>
                <td class="pa-1">{{ props.item.description }}</td>
                <td class="pa-1">{{ props.item.remark }}</td>
                <td class="pa-1">{{ props.item.created_by }}</td>
                <td class="pa-1">{{ epoch2localedatetime(props.item.created) }}</td>
                <td class="pa-1">{{ props.item.modified_by }}</td>
                <td class="pa-1">{{ epoch2localedatetime(props.item.modified) }}</td>
                <td class="pa-1">{{ props.item.status }}</td>
                <td class="pa-1">
                  <v-menu bottom left offset-y>
                    <template v-slot:activator="{ on }">
                      <v-btn small icon v-on="on">
                        <v-icon color="primary">more_vert</v-icon>
                      </v-btn>
                    </template>
                    
                    <v-list dense class="pa-0">
                      <v-list-tile :href="'events_crud?uuid=73953984-a422-4608-b430-bc0f91bbcaaa&_id=' + props.item._id">
                        <v-list-tile-action><v-icon small left>edit</v-icon></v-list-tile-action>
                        <v-list-tile-title>Edit</v-list-tile-title>
                      </v-list-tile>
                      <v-list-tile :href="'events_btrt?uuid=543b1e24-11c8-4178-95a7-84b25968328e&_id=' + props.item._id" v-if="getCurrentStatusOrder(props.item.g_status_id)>1">
                        <v-list-tile-action><v-icon small left>bar_chart</v-icon></v-list-tile-action>
                        <v-list-tile-title>Assessment</v-list-tile-title>
                      </v-list-tile>
                      <v-list-tile :href="'req_log?uuid=3cf1c8fb-3010-4ccb-9fdc-5556d62111c7&Lev=&Lso=' + props.item._id">
                        <v-list-tile-action><v-icon small left>list</v-icon></v-list-tile-action>
                        <v-list-tile-title>Activity Log</v-list-tile-title>
                      </v-list-tile>
                    </v-list>
                  </v-menu>
                </td>
              </template>
							
						</v-data-table>
					</v-card-text>
				</v-card>
			</v-flex>
    </v-layout>
	</v-container>
</template>

<script>
import general from "../../functions/general";
import auth from "../../functions/auth";
import common from "../../functions/general";
import query_builder from "../../functions/query.builder";

export default {
	name:"events_listing",
	data() {
    return {
      // pageid: "",
      username: "",
      event_type: "",
      filters_setting: {
        filter_row: 0,
      },
			selected_filter: [],
      table: {
        rows_per_page_items: [2, 10, 40, 70, 100],
        headers: [
          {
            text: "#ID",
            class: "pa-1 pl-3",
            value: "_id",
            filterable: true,
            sortable: false,
            data_type: "String",
            visible: true
          },
          {
            text: "Type",
            class: "pa-1",
            value: "type",
            filterable: true,
            sortable: true,
            data_type: "String",
            visible: true
          },
          {
            text: "Label",
            class: "pa-1",
            value: "label",
            filterable: true,
            sortable: true,
            data_type: "String",
            visible: true
          },
          {
            text: "Description",
            class: "pa-1",
            value: "description",
            filterable: true,
            sortable: true,
            data_type: "String",
            visible: true
          },
          {
            text: "Remark",
            class: "pa-1",
            value: "remark",
            filterable: true,
            sortable: true,
            data_type: "String",
            visible: true
          },
          {
            text: "Created By",
            // align: "left",
            class: "pa-1",
            value: "created_by",
            filterable: true,            
            sortable: true,
            data_type: "String",
            visible: true
          },
          {
            text: "Created DateTime",
            // align: "left",
            class: "pa-1",
            value: "created",
            filterable: false,            
            sortable: true,
            data_type: "DateTime",
            visible: true
          },
          {
            text: "Modified By",
            // align: "left",
            class: "pa-1",
            value: "modified_by",
            filterable: true,            
            sortable: true,
            data_type: "String",
            visible: true
          },
          {
            text: "Modified DateTime",
            // align: "left",
            class: "pa-1",
            value: "modified",
            filterable: false,            
            sortable: true,
            data_type: "DateTime",
            visible: true
          },
          {
            text: "Status",
            // align: "left",
            class: "pa-1",
            value: "status",
            filterable: true,            
            sortable: true,
            data_type: "String",
            visible: true
          }
        ],
				items: [],
				total_items:0,
				loading: false,
				pagination: {
					descending: true,
					page: 1,
					rowsPerPage: 10,
					sortBy: "created",
					totalItems: 100
				},
      },
      status_option: [],
      auth_role_list: [],
      auth_role: false,
      initiate: false // Note: to avoid 'watch' executed refreshData prior 'mounted'.
		};
  },
  watch: {
    "table.pagination": {
      handler: function() {
        if (this.initiate) {
          this.refreshData();
        }
      },
      deep: true
    }
  },
  async mounted() {
		general.App.set_page_title("mySuite : BTRT");
    // this.pageid = common.App.get_pageID();
    this.username = auth.getUsername();
    this.status_option = await common.App.arango_app_selections("events", "status");

		// Note: get auth-role.
    let res = await common.wBackEndComm.GetData("users/api_get_user_roles/");
    res = res.data;
    if (res.Status == 1) {
      this.auth_role_list = res.Body;
    } else {
      common.wMsgBox.Error(res.Description);
    }
    this.auth_role = common.App.check_role(this.auth_role_list, 9);

    this.initiate = true;
    this.refreshData();
	},
	computed: {
    get_filterable_columns() {
      var return_value = this.table.headers.filter(
        rec => rec.filterable == true
      );
      return return_value;
    }
  },
	methods: {
		epoch2localedatetime: common.App.epoch2LocaleDatetime,
    d_onchange(ind){
      var temp = this.table.headers.find(el => el.value == ind.field);
      ind.type = temp.data_type;
    },
    async refreshData() {
      common.App.loader.show(this);

      var qb = new query_builder.QueryBuilder();
      qb.Table = "events_listing";
      qb.Limit = this.table.pagination.rowsPerPage;
      qb.Offset = this.table.pagination.page;
      
      // must check sortBy before push in order array
      if (this.table.pagination.sortBy) {
        qb.Order = [
          {
            name: this.table.pagination.sortBy,
            descending: this.table.pagination.descending,
          }
        ];
      }

      let filter_len = this.selected_filter.length;
      if (filter_len>0) {
        for (let i = 0; i < filter_len; i++) {
          let rule = new query_builder.Rule();
          switch (this.selected_filter[i].type) {
            case "String":
              rule
                .field(this.selected_filter[i].field)
                .operator(query_builder.A_STR_OPERATOR.I_CONTAINS)
                .value(this.selected_filter[i].value);
              break;
            case "Number":
              break;
            case "Date":
              break;
          }
          qb.Where.rules.push(rule);
        }
      }
      var res = await common.wBackEndComm.PostData("events/events_listing/", qb);
      res = res.data;
      if (res.Status == 1) {
				this.table.items = res.Body[0].records;
				this.table.total_items = res.Body[0].total_records;

        let pp = []
        if (!this.auth_role) {
          let len = this.table.items.length;
          for (let i = 0; i < len; i++) {
            // console.log(this.table.items[i].collaborators);
            let kk = this.table.items[i].collaborators.filter(e => e.username == this.username);
            if (kk.length > 0) {
              pp.push(this.table.items[i]);
            }
          }
          // console.log(pp);
          this.table.items = pp;
          this.table.total_items = pp.length;
        }
      } else {
        common.wMsgBox.Error(res.Description);
      }

      common.App.loader.hide(this);
    },
    getCurrentStatusOrder(cur_status_id) {
      var val = null;      
      var obj = this.status_option.find(function(el){
        return el._id==cur_status_id;
      });

      if (obj){
        val = obj.order;
      }

      return val;
    },
	},
};
</script>

<style></style>
